import { Component, computed, input, Signal, ChangeDetectionStrategy } from '@angular/core';
import { ThemeColor } from '@coin/shared/core/util-models';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { EllipsisTooltipDirective } from '@coin/shared/core/util-directives';

@Component({
  selector: 'coin-c-icon-text-card',
  templateUrl: './icon-text-card.component.html',
  styleUrls: ['./icon-text-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIcon, EllipsisTooltipDirective, MatTooltip]
})
export class IconTextCardComponent {
  public icon = input<string>();
  public iconColor = input<ThemeColor>();
  public svgIcon = input<string>();
  public backgroundColor = input<string>();
  public title = input<string>();
  public subTitle = input<string>();
  public textOverflowBehaviour = input<'wrap' | 'truncate'>('truncate');

  protected shouldTruncateText: Signal<boolean> = computed(() => this.textOverflowBehaviour() === 'truncate');
}
